import React, { PureComponent } from 'react';
import io from 'socket.io-client';
import API_HOST from '../../shared/utils/ApiHost.js';
// import { connect, getData, playerDrafted } from '../../shared/utils/socket.js';
import { store } from "../App/store";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import Standings from './components/Standings';

class StandingsPage extends PureComponent {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    static contextType = store;
    
    constructor(props){
        super(props);
        this.state = {
            db: [],
            standings: [],
            time: ''
        }

        this.socket = io(API_HOST,{
            withCredentials: true,
            extraHeaders: {
                "room": localStorage.getItem('room') !== null ? localStorage.getItem('room') : 'urb_2002'
            }
        });
    }

    componentDidMount = () => {
        const { dispatch } = this.context;

        console.log(window.location.href.indexOf('/update/'))
        if (window.location.href.indexOf('/update/') > -1) {
            let updateInfo = window.location.href.split('/update/')[1];
            if(updateInfo !== '') {
                // update example: 2/03%2F20%2F2022
                let updateUrl = `${API_HOST}/api/tourney/update/${updateInfo}`;
                fetch(updateUrl,{
                    'method':'GET',
                    'credentials': 'include',
                    'headers': {
                        'room': localStorage.getItem('room') !== null ? localStorage.getItem('room') : 'urb_2002'
                    }
                })
                .then(response => {
                    if (!response.ok) throw Error(response.status)
                    return response.json()
                })
                .then(resp => {
                    console.log(JSON.stringify(resp))
                    return resp
                })
                .catch(e => {
                    console.log(e)
                    return e;
                })
            }
        } else {
            this.socket.emit('get_standings','urb_2002')

            this.socket.on('return_standings', data => {
                console.log('return standings')
    
                dispatch({type:'SET_DB',value:data.db})
                dispatch({type:'SET_STANDINGS',value:data.standings})
                
                let year = (new Date()).getFullYear();
                this.setState({
                    db: data.db,
                    standings: data.standings,
                    year: year
                })
    
                
            })
        }

        var duration = 1000 * 60; // 1 minute
        this.interval = setInterval(()=>this.setState({time: (new Date().toLocaleString('en-us','America/Chicago'))}),duration);

    }

    componentWillUnmount = () => {
        clearInterval(this.interval)
    }

    render() {
        const { db, standings, time, year } = this.state;

        return (
            <div id="draft-room-wrapper" className="draftroom">
                <header>
                    <div id="logo"><img src="//mintconditioned.com/mintmadnessdraft/images/mint-madness-logo.svg" alt="Mint Madness" height="90" width="480" /></div>
                    <h1>{year} Standings</h1>
                    <nav>
                        <ul>
                            <li><a href="//mintconditioned.com/mintmadness" target="_blank" rel="noopener noreferrer">Past Results</a></li>
                        </ul>
                    </nav>
                </header>
                <div id="main-content">
                    <Standings db={db} standings={standings} />
                </div>
                <p style={{position: 'fixed', bottom: '-18px', left: '3px', opacity: '0.1'}}>{time}</p>
            </div>
            
            )
    }
    
};

export default withCookies(StandingsPage);
